import { cn } from '@commenda/utils';
import React from 'react';

import { IconButton } from '../../IconButton';
import { Icons } from '../../Icons';
import {
  DATA_GRID_DEFAULT_COLLAPSE_LABEL,
  DATA_GRID_DEFAULT_EXPAND_LABEL,
  DATA_GRID_INDENT_STEP,
} from '../constants';
import { DataGridExpandState } from '../types';

export interface DataGridCellLineItemProps {
  children: React.ReactNode;
  depth?: number;
  indentStep?: number;
  expandState?: DataGridExpandState;
  onToggle?: () => void;
  ariaLabel?: string;
  className?: string;
}

const DataGridCellLineItem = ({
  children,
  depth = 0,
  indentStep = DATA_GRID_INDENT_STEP,
  expandState = 'none',
  onToggle,
  ariaLabel,
  className,
}: DataGridCellLineItemProps) => {
  const isExpanded = expandState === 'expanded';

  return (
    <div
      className={cn(
        'flex w-full items-center justify-between gap-lg',
        className
      )}
      style={depth > 0 ? { paddingLeft: depth * indentStep } : undefined}
    >
      <span className="txt-small-regular min-w-0 flex-1 truncate text-text-primary">
        {children}
      </span>
      {expandState === 'none' ? null : (
        <IconButton
          size="sm"
          variant="default"
          onClick={onToggle}
          aria-label={
            ariaLabel ??
            (isExpanded
              ? DATA_GRID_DEFAULT_COLLAPSE_LABEL
              : DATA_GRID_DEFAULT_EXPAND_LABEL)
          }
          aria-expanded={isExpanded}
          icon={
            isExpanded ? (
              <Icons.Minus className="size-4" />
            ) : (
              <Icons.Plus className="size-4" />
            )
          }
        />
      )}
    </div>
  );
};

export { DataGridCellLineItem };
